import {FORMAT} from '@pluto/daterange-picker';
import {DateRangeState} from '@pluto/daterange-picker/DateRangeTypes';

const humanizeRange = (dates: DateRangeState): [string, string] => {
    if (!dates) {
        return ['', ''];
    }
    
    const {start, end} = dates;
    const dateStart = start?.format(FORMAT) || '';
    const dateEnd = end?.format(FORMAT) || '';
    
    return [dateStart, dateEnd];
};

export default humanizeRange;
